import { useContext, useEffect, useState } from "react";
import { CartContext } from "../../contexts/CartContext";
import { GlobalContext } from "../../contexts/GlobalContext";
import { ProductsContext } from "../../contexts/ProductsContext";
import BtnBase from "../Buttons/BtnBase/BtnBase";

const ModalidadeSelectionStep = ({ nextStep }) => {
  const {
    modalidadesDisponiveis,
    selectedModalidades,
    setModalidadesForItem,
    fetchModalidades,
    confirmarModalidades,
  } = useContext(CartContext);
  const { carrinho } = useContext(GlobalContext);
  const { selectedSubproduct, setSelectedSubproduct, setSelectedProduct } = useContext(ProductsContext);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchModalidades();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const bag = carrinho?.find((b) => b.cartItems?.some((ci) => ci.itemTOTVSId === selectedSubproduct?.id));
  const studentId = bag?.studentId;
  const itemTOTVSId = selectedSubproduct?.id;
  const key = `${studentId}:${itemTOTVSId}`;
  const selecionadas = selectedModalidades[key] ?? [];
  const min = selectedSubproduct?.min_modalidades ?? 1;
  const max = selectedSubproduct?.max_modalidades ?? 1;

  // aguardar carrinho ser populado
  if (!studentId) {
    return (
      <div className="mt-5 flex flex-col justify-center items-center gap-4">
        <p className="text-center text-grey-dark">Preparando seleção de modalidades...</p>
      </div>
    );
  }

  function handleToggle(id) {
    const jaTemModalidade = selecionadas.includes(id);
    const novas = jaTemModalidade
      ? selecionadas.filter((m) => m !== id)
      : [...selecionadas, id];
    setModalidadesForItem(studentId, itemTOTVSId, novas);
  }

  async function handleConfirmar() {
    if (selecionadas.length < min || selecionadas.length > max) {
      setError(
        `Selecione ${min === max ? min : `de ${min} a ${max}`} modalidade(s) antes de continuar.`
      );
      return;
    }
    setSaving(true);
    const ok = await confirmarModalidades();
    setSaving(false);
    if (ok) {
      setSelectedSubproduct();
      setSelectedProduct();
      nextStep();
    } else {
      setError("Erro ao salvar modalidades. Tente novamente.");
    }
  }

  const isCountOk = selecionadas.length >= min && selecionadas.length <= max;

  return (
    <div className="mt-5 flex flex-col justify-center gap-4">
      <h2 className="py-4 text-green-base font-semibold text-center text-base sm:text-2xl">
        Selecione{" "}
        {min === max
          ? `${min} modalidade${min > 1 ? "s" : ""}`
          : `de ${min} a ${max} modalidades`}
      </h2>
      <p className="text-center text-sm" style={{ color: "#888" }}>
        {selecionadas.length} selecionada{selecionadas.length !== 1 ? "s" : ""}
        {" "}
        <span style={{ color: isCountOk ? "#2ca85a" : "#e05252", fontWeight: 600 }}>
          ({min === max ? `necessário: ${min}` : `mínimo: ${min}, máximo: ${max}`})
        </span>
      </p>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          justifyContent: "center",
          marginTop: "8px",
        }}
      >
        {modalidadesDisponiveis.length === 0 && (
          <p className="text-center text-grey-dark">Carregando modalidades...</p>
        )}
        {modalidadesDisponiveis.map((mod) => {
          const checked = selecionadas.includes(mod.id);
          return (
            <label
              key={mod.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "8px 14px",
                borderRadius: "6px",
                border: checked ? "2px solid #2ca85a" : "2px solid #ddd",
                background: checked ? "rgba(44,168,90,0.08)" : "#f9f9f9",
                cursor: "pointer",
                fontWeight: checked ? 600 : 400,
                transition: "all 0.15s",
                userSelect: "none",
              }}
            >
              <input
                type="checkbox"
                checked={checked}
                onChange={() => handleToggle(mod.id)}
                style={{ accentColor: "#2ca85a", width: "16px", height: "16px", cursor: "pointer" }}
              />
              <span>{mod.nome}</span>
            </label>
          );
        })}
      </div>

      {error && (
        <p className="text-center text-sm" style={{ color: "#e05252", marginTop: "4px" }}>
          {error}
        </p>
      )}

      <div className="flex justify-center mt-4">
        <BtnBase
          OnClick={handleConfirmar}
          Disabled={saving}
          BtnTxt={saving ? "Salvando..." : "Confirmar e Continuar"}
          BtnClass={saving ? "btn-disabled-lg" : "btn-yellow-lg"}
        />
      </div>
    </div>
  );
};

export default ModalidadeSelectionStep;
